export const createStatsLabel = (actionName: string) =>
  `${actionName.toLocaleLowerCase().split(' ').join('-')}-internal`;
